import { Component, inject, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { Settings } from 'luxon';
import { NotificationPushService } from './services/notificationPush.service';
import { SupabaseService } from './services/supabase.service';
import { CommonModule } from '@angular/common';
import { CustomToastComponent } from "./shared/ui/custom-toast/custom-toast.component";
import { PageTitleService } from './services/page-title.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, CommonModule, CustomToastComponent],
  template: `
   <p-toast key="toat-message" [baseZIndex]="99999"  appendTo="body"></p-toast>
<app-custom-toast></app-custom-toast>
<router-outlet></router-outlet>
  `,
  styles: [`
    :host {
      display: block;
      height: 100vh;
    }
  `]
})
export class AppComponent implements OnInit {
  title = 'ipay-admin-web';

  private supabaseService = inject(SupabaseService);
  private toastService = inject(NotificationPushService);
  private pageTitleService = inject(PageTitleService);
  private router = inject(Router);
  private dialogService = inject(DialogService);

  ngOnInit() {
    this.pageTitleService.init();

    // Al navegar con las flechas atrás/adelante del navegador, cerrar los diálogos
    // abiertos: si no, la página cambia y el diálogo queda encima con su overlay.
    this.router.events
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart && e.navigationTrigger === 'popstate'))
      .subscribe(() => {
        this.dialogService.dialogComponentRefMap.forEach((_, ref) => ref.close());
      });

    // Settings.defaultZone = 'America/Lima';
    // Fechas formateadas con Luxon (DateTime.toLocaleString, etc.) en español,
    // sin depender del idioma del navegador.
    Settings.defaultLocale = 'es-PE';

    // Escuchar el estado de autenticación globalmente
    // this.supabaseService.client.auth.onAuthStateChange(async (event, session) => {

    //   if (event === 'SIGNED_IN' && session?.user) {
    //     this.toastService.listenToRealtime(session.user.id);
    //   }
    // });
    
    // this.supabaseService.client.auth.onAuthStateChange(async (event, session) => {
    //   if ((event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') && session?.user) {
    //     this.toastService.listenToRealtime(session.user.id);
    //   } else if (event === 'SIGNED_OUT') {
    //     // Implementa un método stopListening() 
    //   }
    // });
  }

}